import { useMemo, useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';
import useEnlog from 'app/hook/common/useEnlog';

function useEnlogEncarpay() {
	const { search } = useLocation();
	const { enloggingJsonData } = useEnlog();
	const { carId: paramCarId } = useParams();
	const {
		from_click,
		carId,
		login: loginYn,
		ew: ewYn,
		extendedWarrantyMonth: ewPeriod,
		payment,
		safecar,
		attributes,
		customerLeadApplicationId: applicationId,
		customerLeadApplicationUuid,
	} = qs.parse(search);

	const defalutParmas = useMemo(
		() => ({
			...(from_click && { from_click }),
			carid: paramCarId || carId || '',
			...(loginYn && { loginYn }),
			...(ewYn && { ewYn }),
			...(ewPeriod && { ewPeriod }),
			...(payment && { payment }),
			...(safecar && { safecar }),
			...(attributes && { attributes }),
			...(applicationId && { applicationId }),
			...(customerLeadApplicationUuid && { status: 'WAIT_CONSULTATION' }), // 홈서비스는 진행단계가 '상담대기중' 상태에서만 한도조회가능
		}),
		[applicationId, attributes, carId, paramCarId, ewPeriod, ewYn, from_click, customerLeadApplicationUuid, loginYn, payment, safecar],
	);

	const dtView = useCallback(
		({ screenName, eventName, eventNameGroup, ...props }) => {
			const data = {
				screenName,
				...(eventName && { eventName }),
				...(eventNameGroup && { eventNameGroup }),
				param: {
					...defalutParmas,
					...props,
				},
			};
			enloggingJsonData({ dataTalkView: data });
		},
		[defalutParmas, enloggingJsonData],
	);

	return { dtView };
}

export default useEnlogEncarpay;
